// extracted by mini-css-extract-plugin
module.exports = {"content":"_6b88b05","infoMessage":"_9cef99f"};